// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3lENu","requiredAsterisk":"Info_requiredAsterisk__hcRCS"};